import React from 'react'

interface GalleryThumbProps {
    isActive: boolean;
    thumbnailUrl: string;
    altText: string;
    onGalleryClick: () => void;
    originalUrl: string;
}

const GalleryThumb = (props:GalleryThumbProps) => {
    return (
        <div onClick={() => props.onGalleryClick()}
            className={props.isActive ? "active" : ""}>
            <img src={props.thumbnailUrl}
                alt={props.altText}
            />
        </div>
    )
}

export default GalleryThumb;